export default {
  emoji: {
    label: 'Emoji',
    icon: 'smile',
    members: [
      'smile',
      'smile-beam',
      'smile-wink',
      'laugh',
      'laugh-beam',
      'laugh-squint',
      'laugh-wink',
      'kiss',
      'kiss-beam',
      'kiss-wink-heart',
      'grimace',
      'grin',
      'grin-alt',
      'grin-beam',
      'grin-beam-sweat',
      'grin-hearts',
      'grin-squint',
      'grin-squint-tears',
      'grin-stars',
      'grin-tears',
      'grin-tongue',
      'grin-tongue-squint',
      'grin-tongue-wink',
      'grin-wink',
      'surprise',
      'meh',
      'meh-blank',
      'meh-rolling-eyes',
      'flushed',
      'tired',
      'dizzy',
      'frown',
      'frown-open',
      'sad-cry',
      'sad-tear',
      'angry',
      'theater-masks',
      'poo',
      'poo-storm',
      'poop',
      'ghost',
      'heart',
      'heart-broken',
      'heartbeat',
      'head-side-cough',
      'head-side-cough-slash',
      'head-side-mask',
      'head-side-virus',
      'brain',
      'skull',
      'skull-crossbones',
      'tooth',
      'teeth',
      'teeth-open',
      'eye',
      'eye-slash',
      'low-vision',
      'lungs',
      'lungs-virus',
      'thumbs-down',
      'thumbs-up',
      'fist-raised',
      'praying-hands',
      'hand-holding',
      'hand-holding-heart',
      'hand-holding-medical',
      'hand-holding-usd',
      'hand-holding-water',
      'hand-lizard',
      'hand-middle-finger',
      'allergies',
      'hand-paper',
      'hand-peace',
      'hand-point-down',
      'hand-point-left',
      'hand-point-right',
      'hand-point-up',
      'hand-pointer',
      'hand-rock',
      'hand-scissors',
      'hand-sparkles',
      'hand-spock',
      'hands',
      'hands-helping',
      'hands-wash',
      'handshake',
      'handshake-alt-slash',
      'handshake-slash',
    ],
  },
  people: {
    label: 'People',
    icon: 'user',
    members: [
      'user',
      'user-alt',
      'user-alt-slash',
      'user-astronaut',
      'user-check',
      'user-circle',
      'user-clock',
      'user-cog',
      'user-edit',
      'user-friends',
      'user-graduate',
      'user-injured',
      'user-lock',
      'user-md',
      'user-minus',
      'user-ninja',
      'user-nurse',
      'user-plus',
      'user-secret',
      'user-shield',
      'user-slash',
      'user-tag',
      'user-tie',
      'user-times',
      'users',
      'users-cog',
      'users-slash',
      'people-arrows',
      'male',
      'female',
      'baby',
      'child',
      'procedures',
      'hot-tub',
      'pray',
      'walking',
      'wheelchair',
      'people-carry',
      'person-booth',
      'street-view',
      'blind',
      'biking',
      'shower',
      'swimmer',
      'running',
      'skating',
      'skiing',
      'skiing-nordic',
      'snowboarding',
      'hiking',
      'diagnoses',
    ],
  },
  business: {
    label: 'Business',
    icon: 'briefcase',
    members: [
      'briefcase',
      'briefcase-medical',
      'suitcase',
      'suitcase-rolling',
      'shopping-bag',
      'shopping-basket',
      'shopping-cart',
      'cart-plus',
      'cart-arrow-down',
      'sms',
      'comment',
      'comment-alt',
      'comment-dollar',
      'comment-dots',
      'comment-medical',
      'comment-slash',
      'comments',
      'comments-dollar',
      'donate',
      'address-book',
      'address-card',
      'id-badge',
      'id-card',
      'id-card-alt',
      'portrait',
      'book',
      'book-dead',
      'book-medical',
      'atlas',
      'journal-whills',
      'passport',
      'book-open',
      'book-reader',
      'bookmark',
      'business-time',
      'calendar',
      'calendar-alt',
      'calendar-check',
      'calendar-day',
      'calendar-minus',
      'calendar-plus',
      'calendar-times',
      'calendar-week',
      'chart-area',
      'chart-bar',
      'chart-line',
      'chart-pie',
      'project-diagram',
      'network-wired',
      'clipboard',
      'clipboard-check',
      'clipboard-list',
      'notes-medical',
      'tasks',
      'clock',
      'download',
      'cloud-download-alt',
      'upload',
      'cloud-upload-alt',
      'credit-card',
      'newspaper',
      'receipt',
      'inbox',
      'envelope',
      'envelope-open',
      'envelope-open-text',
      'envelope-square',
      'mail-bulk',
      'thumbtack',
      'paperclip',
      'pen',
      'pen-alt',
      'pen-fancy',
      'pen-nib',
      'pen-square',
      'pencil-alt',
      'pencil-ruler',
      'highlighter',
      'marker',
      'eraser',
      'tape',
      'tag',
      'tags',
      'file',
      'file-alt',
      'file-archive',
      'file-audio',
      'file-code',
      'file-contract',
      'file-csv',
      'file-download',
      'file-excel',
      'file-export',
      'file-image',
      'file-import',
      'file-invoice',
      'file-invoice-dollar',
      'file-medical',
      'file-medical-alt',
      'file-pdf',
      'file-powerpoint',
      'file-prescription',
      'file-signature',
      'file-upload',
      'file-video',
      'file-word',
      'archive',
      'folder',
      'folder-minus',
      'folder-open',
      'folder-plus',
      'funnel-dollar',
      'globe',
      'globe-africa',
      'globe-americas',
      'globe-asia',
      'globe-europe',
      'mouse',
      'keyboard',
      'save',
      'tty',
      'fax',
      'cash-register',
      'calculator',
      'print',
      'headphones',
      'headphones-alt',
      'headset',
      'mobile',
      'mobile-alt',
      'tablet',
      'tablet-alt',
      'laptop',
      'laptop-code',
      'laptop-house',
      'laptop-medical',
      'desktop',
      'chalkboard',
      'chalkboard-teacher',
      'map',
      'map-marked',
      'map-marked-alt',
      'map-marker',
      'map-marker-alt',
      'map-pin',
      'map-signs',
      'microphone',
      'microphone-alt',
      'microphone-alt-slash',
      'microphone-slash',
      'phone',
      'phone-alt',
      'phone-slash',
      'phone-square',
      'phone-square-alt',
      'phone-volume',
      'voicemail',
      'sitemap',
      'stamp',
      'sticky-note',
      'store',
      'store-alt',
      'store-alt-slash',
      'store-slash',
      'trash',
      'trash-alt',
      'trash-restore',
      'trash-restore-alt',
      'signature',
      'certificate',
      'award',
      'medal',
      'trophy',
      'key',
      'fingerprint',
      'vote-yea',
      'coins',
      'wallet',
      'money-bill',
      'money-bill-alt',
      'money-bill-wave',
      'money-bill-wave-alt',
      'money-check',
      'money-check-alt',
      'dollar-sign',
      'pound-sign',
      'euro-sign',
      'yen-sign',
      'won-sign',
      'lira-sign',
      'ruble-sign',
      'rupee-sign',
      'shekel-sign',
      'tenge',
    ],
  },
  places: {
    label: 'Places',
    icon: 'building',
    members: [
      'home',
      'house-user',
      'house-damage',
      'warehouse',
      'school',
      'university',
      'landmark',
      'archway',
      'restroom',
      'road',
      'route',
      'city',
      'industry',
      'broadcast-tower',
      'clinic-medical',
      'dungeon',
      'building',
      'hospital',
      'hospital-alt',

      'hospital-user',
      'hotel',
      'gas-pump',
      'place-of-worship',
      'monument',
      'mosque',
      'kaaba',
      'church',
      'synagogue',
      'vihara',
      'torii-gate',
      'gopuram',
      'mountain',
      'igloo',
      'motorcycle',
      'car',
      'car-alt',
      'car-crash',
      'car-side',
      'caravan',
      'bus',
      'bus-alt',
      'taxi',
      'shuttle-van',
      'ambulance',
      'shipping-fast',
      'truck',
      'truck-loading',
      'truck-monster',
      'truck-moving',
      'truck-pickup',
      'tractor',
      'traffic-light',
      'trailer',
      'subway',
      'train',
      'tram',
      'ship',
      'rocket',
      'fighter-jet',
      'space-shuttle',
      'helicopter',
      'plane',
      'plane-arrival',
      'plane-departure',
      'plane-slash',
    ],
  },
  activities: {
    label: 'Activities',
    icon: 'futbol',
    members: [
      'dumbbell',
      'futbol',
      'baseball-ball',
      'basketball-ball',
      'football-ball',
      'bowling-ball',
      'golf-ball',
      'volleyball-ball',
      'hockey-puck',
      'table-tennis',
      'drum',
      'drum-steelpan',
      'guitar',
      'palette',
      'paint-brush',
      'paint-roller',
      'music',
      'image',
      'images',
      'film',
      'photo-video',
      'video',
      'video-slash',
      'gamepad',
      'camera',
      'camera-retro',
      'campground',
      'gifts',
      'chess',
      'chess-bishop',
      'chess-board',
      'chess-king',
      'chess-knight',
      'chess-pawn',
      'chess-queen',
      'chess-rook',
      'dice',
      'dice-d20',
      'dice-d6',
      'dice-five',
      'dice-four',
      'dice-one',
      'dice-six',
      'dice-three',
      'dice-two',
      'bicycle',
      'bath',
      'bed',
      'swimming-pool',
      'umbrella-beach',
      'parachute-box',
      'sleigh',
      'snowman',
      'snowplow',
    ],
  },
  food: {
    label: 'Food',
    icon: 'pizza-slice',
    members: [
      'apple-alt',
      'lemon',
      'hamburger',
      'pizza-slice',
      'stroopwafel',
      'hotdog',
      'birthday-cake',
      'bread-slice',
      'candy-cane',
      'cookie',
      'cookie-bite',
      'drumstick-bite',
      'bacon',
      'cheese',
      'carrot',
      'pepper-hot',
      'holly-berry',
      'egg',
      'pills',
      'capsules',
      'tablets',
      'ice-cream',
      'coffee',
      'mug-hot',
      'glass-cheers',
      'wine-glass',
      'wine-glass-alt',
      'cocktail',
      'glass-martini',
      'glass-martini-alt',
      'glass-whiskey',
      'wine-bottle',
      'utensils',
      'utensil-spoon',
    ],
  },
  natures: {
    label: 'Natures',
    icon: 'tree',
    members: [
      'moon',
      'sun',
      'cloud',
      'cloud-meatball',
      'cloud-moon',
      'cloud-moon-rain',
      'cloud-rain',
      'cloud-showers-heavy',
      'cloud-sun',
      'cloud-sun-rain',
      'smog',
      'bolt',
      'rainbow',
      'water',
      'icicles',
      'snowflake',
      'wind',
      'fire',
      'fire-alt',
      'burn',
      'meteor',
      'bone',
      'seedling',
      'tree',
      'leaf',
      'cannabis',
      'cat',
      'dog',
      'dove',
      'dragon',
      'horse',
      'horse-head',
      'kiwi-bird',
      'crow',
      'hippo',
      'bug',
      'spider',
      'fish',
      'frog',
      'otter',
      'pastafarianism',
      'paw',
      'disease',
      'bacteria',
      'bacterium',
      'virus',
      'virus-slash',
      'viruses',
    ],
  },
  objects: {
    label: 'Objects',
    icon: 'lightbulb',
    members: [
      'socks',
      'tshirt',
      'vest',
      'vest-patches',
      'umbrella',
      'mask',
      'glasses',
      'binoculars',
      'hard-hat',
      'graduation-cap',
      'hat-cowboy',
      'hat-cowboy-side',
      'hat-wizard',
      'ruler',
      'ruler-combined',
      'ruler-horizontal',
      'ruler-vertical',
      'lightbulb',
      'car-battery',
      'battery-empty',
      'battery-full',
      'battery-half',
      'battery-quarter',
      'battery-three-quarters',
      'charging-station',
      'tv',
      'vr-cardboard',
      'memory',
      'sim-card',
      'sd-card',
      'microchip',
      'database',
      'hdd',
      'server',
      'ethernet',
      'fan',
      'plug',
      'compact-disc',
      'blender',
      'blender-phone',
      'pager',
      'digital-tachograph',
      'tachometer-alt',
      'robot',
      'satellite',
      'satellite-dish',
      'solar-panel',
      'thermometer',
      'thermometer-empty',
      'thermometer-full',
      'thermometer-half',
      'thermometer-quarter',
      'thermometer-three-quarters',
      'temperature-high',
      'temperature-low',
      'fire-extinguisher',
      'medkit',
      'first-aid',
      'band-aid',
      'syringe',
      'microscope',
      'bong',
      'flask',
      'vial',
      'vials',
      'mortar-pestle',
      'prescription-bottle',
      'prescription-bottle-alt',
      'pump-medical',
      'pump-soap',
      'soap',
      'spray-can',
      'stethoscope',
      'shield-alt',
      'shield-virus',
      'air-freshener',
      'anchor',
      'bell',
      'bell-slash',
      'bomb',
      'bullhorn',
      'bullseye',
      'compass',
      'concierge-bell',
      'crown',
      'crutch',
      'cube',
      'cubes',
      'box',
      'boxes',
      'box-open',
      'pallet',
      'luggage-cart',
      'dolly',
      'dolly-flatbed',
      'baby-carriage',
      'drafting-compass',
      'dumpster',
      'dumpster-fire',
      'feather',
      'feather-alt',
      'flag',
      'flag-checkered',
      'flag-usa',
      'gem',
      'gift',
      'joint',
      'life-ring',
      'magnet',
      'mitten',
      'neuter',
      'paper-plane',
      'piggy-bank',
      'puzzle-piece',
      'ribbon',
      'ring',
      'scroll',
      'stopwatch',
      'stopwatch-20',
      'swatchbook',
      'ticket-alt',
      'chair',
      'couch',
      'door-closed',
      'door-open',
      'faucet',
      'sink',
      'toilet',
      'toilet-paper',
      'toilet-paper-slash',
      'box-tissue',
      'broom',
      'brush',
      'oil-can',
      'wrench',
      'screwdriver',
      'hammer',
      'gavel',
      'toolbox',
      'tools',
      'cog',
      'cogs',
      'weight',
      'weight-hanging',
      'balance-scale',
      'balance-scale-left',
      'balance-scale-right',
    ],
  },
  symbols: {
    label: 'Symbols',
    icon: 'hashtag',
    members: [
      'plus',
      'plus-circle',
      'plus-square',
      'minus',
      'minus-circle',
      'minus-square',
      'times',
      'times-circle',
      'divide',
      'percent',
      'percentage',
      'square-root-alt',
      'equals',
      'not-equal',
      'greater-than',
      'greater-than-equal',
      'less-than',
      'less-than-equal',
      'infinity',
      'hashtag',
      'asterisk',
      'at',
      'slash',
      'angle-double-down',
      'angle-double-left',
      'angle-double-right',
      'angle-double-up',
      'angle-down',
      'angle-left',
      'angle-right',
      'angle-up',
      'arrow-alt-circle-down',
      'arrow-alt-circle-left',
      'arrow-alt-circle-right',
      'arrow-alt-circle-up',
      'arrow-circle-down',
      'arrow-circle-left',
      'arrow-circle-right',
      'arrow-circle-up',
      'arrow-down',
      'arrow-left',
      'arrow-right',
      'arrow-up',
      'arrows-alt',
      'arrows-alt-h',
      'arrows-alt-v',
      'long-arrow-alt-down',
      'long-arrow-alt-left',
      'long-arrow-alt-right',
      'long-arrow-alt-up',
      'location-arrow',
      'mouse-pointer',
      'level-down-alt',
      'level-up-alt',
      'caret-down',
      'caret-left',
      'caret-right',
      'caret-up',
      'caret-square-down',
      'caret-square-left',
      'caret-square-right',
      'caret-square-up',
      'chevron-down',
      'chevron-left',
      'chevron-right',
      'chevron-up',
      'chevron-circle-down',
      'chevron-circle-left',
      'chevron-circle-right',
      'chevron-circle-up',
      'check',
      'check-circle',
      'check-double',
      'check-square',
      'backspace',
      'closed-captioning',
      'info',
      'info-circle',
      'question',
      'question-circle',
      'exclamation',
      'exclamation-circle',
      'exclamation-triangle',
      'reply',
      'reply-all',
      'share',
      'share-alt',
      'share-alt-square',
      'share-square',
      'retweet',
      'external-link-alt',
      'external-link-square-alt',
      'random',
      'exchange-alt',
      'undo',
      'undo-alt',
      'redo',
      'redo-alt',
      'history',
      'crop',
      'crop-alt',
      'object-group',
      'object-ungroup',
      'layer-group',
      'clone',
      'expand',
      'expand-alt',
      'expand-arrows-alt',
      'compress',
      'compress-alt',
      'compress-arrows-alt',
      'draw-polygon',
      'bezier-curve',
      'vector-square',
      'adjust',
      'tint',
      'tint-slash',
      'eye-dropper',
      'fill',
      'fill-drip',
      'toggle-off',
      'toggle-on',
      'filter',
      'search',
      'search-dollar',
      'search-location',
      'search-minus',
      'search-plus',
      'sign-in-alt',
      'sign-out-alt',
      'sort',
      'sort-alpha-down',
      'sort-alpha-down-alt',
      'sort-alpha-up',
      'sort-alpha-up-alt',
      'sort-amount-down',
      'sort-amount-down-alt',
      'sort-amount-up',
      'sort-amount-up-alt',
      'sort-down',
      'sort-numeric-down',
      'sort-numeric-down-alt',
      'sort-numeric-up',
      'sort-numeric-up-alt',
      'sort-up',
      'edit',
      'copy',
      'cut',
      'paste',
      'i-cursor',
      'paragraph',
      'spell-check',
      'heading',
      'font',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'subscript',
      'superscript',
      'indent',
      'outdent',
      'quote-left',
      'quote-right',
      'link',
      'unlink',
      'align-center',
      'align-justify',
      'align-left',
      'align-right',
      'remove-format',
      'text-height',
      'text-width',
      'list',
      'list-alt',
      'list-ol',
      'list-ul',
      'border-all',
      'border-none',
      'border-style',
      'columns',
      'table',
      'th',
      'th-large',
      'th-list',
      'grip-horizontal',
      'grip-lines',
      'grip-lines-vertical',
      'grip-vertical',
      'bars',
      'ellipsis-h',
      'ellipsis-v',
      'spinner',
      'hourglass',
      'hourglass-end',
      'hourglass-half',
      'hourglass-start',
      'sync',
      'sync-alt',
      'lock',
      'lock-open',
      'unlock',
      'unlock-alt',
      'code',
      'code-branch',
      'terminal',
      'icons',
      'shapes',
      'circle',
      'circle-notch',
      'dot-circle',
      'square',
      'square-full',
      'eject',
      'play',
      'play-circle',
      'pause',
      'pause-circle',
      'stop',
      'stop-circle',
      'backward',
      'fast-backward',
      'step-backward',
      'forward',
      'fast-forward',
      'step-forward',
      'volume-down',
      'volume-mute',
      'volume-off',
      'volume-up',
      'power-off',
      'wifi',
      'signal',
      'sliders-h',
      'window-close',
      'window-maximize',
      'window-minimize',
      'window-restore',
      'mars',
      'mars-double',
      'mars-stroke',
      'mars-stroke-h',
      'mars-stroke-v',
      'venus',
      'venus-double',
      'venus-mars',
      'transgender',
      'transgender-alt',
      'genderless',
      'shoe-prints',
      'splotch',
      'smoking',
      'smoking-ban',
      'ban',
      'wave-square',
      'stream',
      'quidditch',
      'prescription',
      'record-vinyl',
      'poll',
      'poll-h',
      'podcast',
      'blog',
      'om',
      'magic',
      'directions',
      'crosshairs',
      'sign',
      'braille',
      'deaf',
      'assistive-listening-systems',
      'sign-language',
      'american-sign-language-interpreting',
      'dna',
      'atom',
      'mercury',
      'biohazard',
      'radiation',
      'radiation-alt',
      'recycle',
      'x-ray',
      'star',
      'spa',
      'star-half',
      'star-half-alt',
      'star-of-life',
      'hryvnia',
      'democrat',
      'republican',
      'peace',
      'quran',
      'bible',
      'torah',
      'star-and-crescent',
      'cross',
      'star-of-david',
      'yin-yang',
      'bahai',
      'hamsa',
      'ankh',
      'hanukiah',
      'menorah',
      'jedi',
      'khanda',
      'dharmachakra',
      'language',
      'universal-access',
      'ad',
      'copyright',
      'trademark',
      'registered',
      'audio-description',
      'parking',
      'hospital-symbol',
      'h-square',
      'rss',
      'rss-square',
      'qrcode',
      'barcode',
    ],
  },
};
